<div class="flex flex-row justify-center items-center max-w-lvw">
    <form class="w-full md:w-4/5" [formGroup]="namesForm" (ngSubmit)="saveFirstAndLastName()">
        <pin-card>
            <pin-card-title [centered]="true" role="complementary">
                Please enter your first and last name to complete your DCP profile.
            </pin-card-title>

            <pin-card-content role="main">
                <div class="flex flex-row text-center">
                    <p class="dcp-body">
                        Your first and last name will be used to provide you with a more personalized experience.
                    </p>
                </div>

                <div class="flex flex-row justify-between items-center gap-6">
                    <mat-form-field class="flex-1 w-full" appearance="outline" id="first.name">
                        <mat-label id="firstNameLabel">First Name</mat-label>

                        <input matInput placeholder="First Name"
                               maxlength="50"
                               formControlName="firstName"
                               pinAutoFocus
                               pinTrimField
                               (keyup)="namesForm.controls['firstName'].markAsTouched()"
                               aria-label="First Name">

                        @if (namesForm.controls['firstName'].hasError('required')) {
                          <mat-error id="firstName.required" i18n="@@firstName.required">
                              First Name is required
                          </mat-error>
                        }
                        @if (namesForm.controls['firstName'].hasError('nonAsciiPrintable')) {
                          <mat-error>This field cannot contain invalid characters.</mat-error>
                        }
                    </mat-form-field>

                    <mat-form-field class="flex-1 w-full" appearance="outline" id="last.name">
                        <mat-label id="lastNameLabel">Last Name</mat-label>

                        <input matInput placeholder="Last Name"
                               maxlength="50"
                               formControlName="lastName"
                               (keyup)="namesForm.controls['firstName'].markAsTouched()"
                               pinTrimField
                               aria-label="Last Name">
                        @if (namesForm.controls['lastName'].hasError('required')) {
                          <mat-error id="lastName.required" i18n="@@lastName.required">
                              Last Name is required
                          </mat-error>
                        }
                        @if (namesForm.controls['lastName'].hasError('nonAsciiPrintable')) {
                          <mat-error>This field cannot contain invalid characters.</mat-error>
                        }
                    </mat-form-field>
                </div>
            </pin-card-content>

            <pin-card-actions role="complementary" aria-label="CONFIRM ENTERED NAMES AND CONTINUE" class="w-full mt-4">
                <div class="flex justify-end items-center">
                    <pin-button buttonStyle="filled" buttonId="confirm-setup-name-button" [isDisabled]="isLoading">SAVE AND CONTINUE</pin-button>
                </div>
            </pin-card-actions>
        </pin-card>

        @if (isLoading) {
          <div class="pin-spinner fullscreen">
              <mat-progress-spinner mode="indeterminate"></mat-progress-spinner>
          </div>
        }
    </form>
</div>
